import type { UseFormGetValues } from "react-hook-form";
import type { LeadResponse } from "~www/types/forms/lead-response";
import type {
  CarePlusInquiryFormData,
  CarePlusInquiryResponse,
} from "./carePlusInquiry.schema";

type CarePlusSubmitResult = "success" | "server-error" | "validation-error";

function getCarePlusInquiryTrackingProperties(
  result: CarePlusSubmitResult,
  getFormValues: UseFormGetValues<CarePlusInquiryFormData>,
  tags: LeadResponse<CarePlusInquiryResponse>["tags"],
) {
  return {
    care_for: getFormValues("careFor"),
    email: getFormValues("email"),
    first_name: getFormValues("firstName"),
    form_submission_result: result,
    last_name: getFormValues("lastName"),
    phone: getFormValues("phone"),
    tags,
  };
}

export { getCarePlusInquiryTrackingProperties };
